<template>
  <footer class="bg-gray-900 text-gray-300">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div class="grid grid-cols-1 md:grid-cols-4 gap-8">
        <CompanyInfo />
        <ContactInfo />
        <QuickLinks />
        <LegalInfo />
      </div>
      <Copyright />
    </div>
  </footer>
</template>

<script setup lang="ts">
import CompanyInfo from './footer/CompanyInfo.vue'
import ContactInfo from './footer/ContactInfo.vue'
import QuickLinks from './footer/QuickLinks.vue'
import LegalInfo from './footer/LegalInfo.vue'
import Copyright from './footer/Copyright.vue'
</script>